import { getModule } from "src/system/getModule.ts";

// rename to useModuleConfig?
export const useModule = (resource: string) => {
  return getModule(resource);
};
